import React, { useEffect, useState } from "react"
import { FiEye, FiXCircle } from "react-icons/fi"

import Input from "../InputUnform"

import { Form } from "@unform/web"

import {
  Button,
  ButtonGroup,
  Dialog,
  DialogMessage,
  DialogTitle,
  Overlay,
  CloseButton,
} from "./style"

interface ConfirmationDialogProps {
  open: boolean
  title: string
  message: string
  onConfirm: (obs: string) => void
  onCancel: () => void
  onClose?: () => void
}

const ConfirmationModal: React.FC<ConfirmationDialogProps> = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  onClose,
}) => {
  const [obs, setObs] = useState("")

  useEffect(() => {
    if (open) {
      setObs("")
    }
  }, [open])

  return (
    <Overlay open={open}>
      <Dialog>
        <CloseButton onClick={onClose}>
          <FiXCircle />
        </CloseButton>

        <DialogTitle>{title}</DialogTitle>

        <DialogMessage>{message}</DialogMessage>

        <Form onSubmit={() => {}}>
          <Input
            name="obs"
            icon={FiEye}
            type="text"
            placeholder="Observações"
            containerStyle={{ flex: 3 }}
            value={obs}
            onChange={(e) => setObs(e.target.value)}
          />
        </Form>

        <ButtonGroup>
          <Button
            variant={"confirm"}
            onClick={() => {
              onConfirm(obs)
            }}
          >
            Confirmar
          </Button>
          <Button variant={"cancel"} onClick={onCancel}>
            Cancelar
          </Button>
        </ButtonGroup>
      </Dialog>
    </Overlay>
  )
}

export default ConfirmationModal
